var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { loading: _vm.loading } },
    [
      _c(
        "div",
        { staticClass: "fixedButton", staticStyle: { margin: "10px 0" } },
        [
          _c(
            "vxe-button",
            { staticClass: "examineButton", on: { click: _vm.ReturnFun } },
            [_vm._v("返回")]
          ),
          _vm.approveBtnType === "1"
            ? _c(
                "vxe-button",
                {
                  staticClass: "examineButton",
                  attrs: { status: "primary" },
                  on: {
                    click: function ($event) {
                      return _vm.handleApprove(0)
                    },
                  },
                },
                [_vm._v("发起审批")]
              )
            : _vm._e(),
          _vm.approveBtnType === "3"
            ? _c(
                "vxe-button",
                {
                  staticClass: "examineButton",
                  attrs: { status: "primary" },
                  on: {
                    click: function ($event) {
                      return _vm.handleApprove(5)
                    },
                  },
                },
                [_vm._v("重新发起审批")]
              )
            : _vm._e(),
          _vm.approveBtnType === "2"
            ? _c(
                "vxe-button",
                {
                  staticClass: "examineButton",
                  attrs: { status: "primary" },
                  on: {
                    click: function ($event) {
                      return _vm.handleApprove(1)
                    },
                  },
                },
                [_vm._v("同意")]
              )
            : _vm._e(),
          _vm.approveBtnType === "2"
            ? _c(
                "vxe-button",
                {
                  staticClass: "examineButton",
                  attrs: { status: "warning" },
                  on: {
                    click: function ($event) {
                      return _vm.handleApprove(2)
                    },
                  },
                },
                [_vm._v("退给上一审批人")]
              )
            : _vm._e(),
          _vm.approveBtnType === "2"
            ? _c(
                "vxe-button",
                {
                  staticClass: "examineButton",
                  attrs: { status: "danger" },
                  on: {
                    click: function ($event) {
                      return _vm.handleApprove(3)
                    },
                  },
                },
                [_vm._v("驳回")]
              )
            : _vm._e(),
          _vm.approveBtnType === "2"
            ? _c(
                "vxe-button",
                {
                  staticClass: "examineButton",
                  attrs: { status: "danger" },
                  on: {
                    click: function ($event) {
                      return _vm.handleApprove(6)
                    },
                  },
                },
                [_vm._v("不同意")]
              )
            : _vm._e(),
          _vm.approveBtnType === "2"
            ? _c(
                "vxe-button",
                {
                  staticClass: "examineButton",
                  on: {
                    click: function ($event) {
                      return _vm.handleApprove(4)
                    },
                  },
                },
                [_vm._v("转派")]
              )
            : _vm._e(),
        ],
        1
      ),
      _c(
        "div",
        {
          staticClass:
            "CertificateReleaseApplicationBox scrollBars ActivityPlanReviewExamine",
          style: "height:" + (_vm.$store.state.app.height - 70) + "px;",
        },
        [
          _c(
            "el-collapse",
            {
              staticClass: "collapse-box",
              model: {
                value: _vm.activityInfo,
                callback: function ($$v) {
                  _vm.activityInfo = $$v
                },
                expression: "activityInfo",
              },
            },
            [
              _c(
                "el-collapse-item",
                { staticClass: "collapseItem", attrs: { title: "活动信息" } },
                [
                  _c("ActivityMaintenanceInformation", {
                    attrs: { data: _vm.activity },
                  }),
                  _c("ActivityReportingInformation", {
                    attrs: {
                      data: _vm.signData,
                      activity: _vm.activity,
                      "file-list": _vm.fileList.actPlanApply,
                      approveBtnType: _vm.approveBtnType,
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-collapse",
            {
              staticClass: "collapse-box",
              model: {
                value: _vm.collapseNumber,
                callback: function ($$v) {
                  _vm.collapseNumber = $$v
                },
                expression: "collapseNumber",
              },
            },
            [
              _c(
                "el-collapse-item",
                {
                  staticClass: "collapseItem",
                  attrs: { title: "活动核销信息", name: "default" },
                },
                [
                  _c(
                    "el-form",
                    {
                      ref: "formOne",
                      staticClass: "UniformCss",
                      attrs: { model: _vm.Reimburse, "label-width": "130px" },
                    },
                    [
                      _c(
                        "el-row",
                        [
                          _c(
                            "el-col",
                            { attrs: { span: 8 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  staticClass: "form-item",
                                  attrs: { label: "提报审批金额" },
                                },
                                [
                                  _c("a-input", {
                                    attrs: { disabled: "" },
                                    model: {
                                      value: _vm.signData.approveApplyCost,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.signData,
                                          "approveApplyCost",
                                          $$v
                                        )
                                      },
                                      expression: "signData.approveApplyCost",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 8 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  staticClass: "form-item",
                                  attrs: {
                                    label: "实际时间",
                                    prop: "actualStartTime",
                                  },
                                },
                                [
                                  _c("a-date-picker", {
                                    attrs: { type: "date", disabled: "" },
                                    model: {
                                      value: _vm.signData.actualStartTime,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.signData,
                                          "actualStartTime",
                                          $$v
                                        )
                                      },
                                      expression: "signData.actualStartTime",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 8 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  staticClass: "form-item",
                                  attrs: {
                                    label: "现场订车数",
                                    prop: "orderQuantity",
                                  },
                                },
                                [
                                  _c("a-input", {
                                    attrs: { disabled: "" },
                                    model: {
                                      value: _vm.signData.orderQuantity,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.signData,
                                          "orderQuantity",
                                          $$v
                                        )
                                      },
                                      expression: "signData.orderQuantity",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-row",
                        [
                          _c("div", { staticClass: "item-line" }, [
                            _vm._v("审核费用确认明细"),
                          ]),
                          _vm._l(
                            _vm.activityVisibilityMap[
                              _vm.getFormByActivity(_vm.activity.threeLevelName)
                            ],
                            function (f) {
                              return _c(
                                "a-col",
                                { key: f, attrs: { span: 6 } },
                                [
                                  _c(
                                    "el-form-item",
                                    {
                                      staticClass: "form-item",
                                      attrs: {
                                        label:
                                          _vm.activityFeeFieldList[f].label,
                                      },
                                    },
                                    [
                                      _c("a-input-number", {
                                        attrs: {
                                          min: _vm.activityFeeFieldList[f].min,
                                          disabled: _vm.isDisabled(),
                                        },
                                        on: {
                                          blur: function ($event) {
                                            return _vm.setZeroIfEmpty(f)
                                          },
                                          change: _vm.getActualCost,
                                        },
                                        model: {
                                          value: _vm.signData[f],
                                          callback: function ($$v) {
                                            _vm.$set(_vm.signData, f, $$v)
                                          },
                                          expression: "signData[f]",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              )
                            }
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 6 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: false,
                                      expression: "false",
                                    },
                                  ],
                                  staticClass: "form-item",
                                  attrs: {
                                    label: "实际执行费用(元)",
                                    prop: "actualCost",
                                  },
                                },
                                [
                                  _c("a-input", {
                                    attrs: { disabled: "" },
                                    model: {
                                      value: _vm.signData.actualCost,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.signData,
                                          "actualCost",
                                          $$v
                                        )
                                      },
                                      expression: "signData.actualCost",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 6 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  staticClass: "form-item",
                                  attrs: {
                                    label: "核销审核费用(元)",
                                    prop: "writeoffApproveFee",
                                  },
                                },
                                [
                                  _c("a-input", {
                                    attrs: { disabled: "" },
                                    model: {
                                      value: _vm.formattedapproveWriteoffCost,
                                      callback: function ($$v) {
                                        _vm.formattedapproveWriteoffCost = $$v
                                      },
                                      expression:
                                        "formattedapproveWriteoffCost",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 6 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  staticClass: "form-item",
                                  attrs: { label: "考评金额(元)" },
                                },
                                [
                                  _c("a-input", {
                                    attrs: { title: "number", disabled: "" },
                                    model: {
                                      value: this.signData.assessmentCost,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          this.signData,
                                          "assessmentCost",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "this.signData.assessmentCost",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        2
                      ),
                      _c(
                        "el-row",
                        [
                          _c(
                            "el-col",
                            { attrs: { span: 6 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  staticClass: "form-item",
                                  attrs: { label: "开票时间" },
                                },
                                [
                                  _c("el-date-picker", {
                                    staticStyle: { width: "200px" },
                                    attrs: {
                                      "value-format": "yyyy-MM-dd",
                                      type: "daterange",
                                      "range-separator": "-",
                                      "start-placeholder": "开始日期",
                                      "end-placeholder": "结束日期",
                                    },
                                    on: { change: _vm.onTimeChange },
                                    model: {
                                      value: _vm.invoicingTime,
                                      callback: function ($$v) {
                                        _vm.invoicingTime = $$v
                                      },
                                      expression: "invoicingTime",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "a-col",
                            { attrs: { span: 6 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  staticClass: "form-item",
                                  attrs: { label: "开票数" },
                                },
                                [
                                  _c("a-input", {
                                    attrs: { disabled: "" },
                                    model: {
                                      value: _vm.invoicingNumber,
                                      callback: function ($$v) {
                                        _vm.invoicingNumber = $$v
                                      },
                                      expression: "invoicingNumber",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 6 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  staticClass: "form-item",
                                  attrs: { label: "集客实际" },
                                },
                                [
                                  _c("a-input-number", {
                                    attrs: {
                                      disabled: "",
                                      min: 0,
                                      precision: 0,
                                      placeholder: "请输入集客实际数量",
                                    },
                                    model: {
                                      value: _vm.signData.customerActual,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.signData,
                                          "customerActual",
                                          $$v
                                        )
                                      },
                                      expression: "signData.customerActual",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 6 } },
                            [
                              _c(
                                "el-form-item",
                                { staticClass: "form-item" },
                                [
                                  _c(
                                    "a-button",
                                    {
                                      attrs: { type: "link" },
                                      on: { click: _vm.showCustomerModal },
                                    },
                                    [_vm._v("扫码集客数据查看")]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-row",
                        [
                          _c(
                            "el-col",
                            {
                              staticStyle: { height: "auto" },
                              attrs: { span: 24 },
                            },
                            [
                              _c(
                                "div",
                                { staticStyle: { float: "left" } },
                                [
                                  _c(
                                    "el-form-item",
                                    {
                                      staticClass: "form-item",
                                      attrs: { label: "增值税发票:" },
                                    },
                                    [
                                      _c("el-upload", {
                                        staticClass: "noneupload",
                                        staticStyle: { display: "none" },
                                        attrs: {
                                          action: "",
                                          "on-preview": _vm.onPreviewFun,
                                          "file-list":
                                            _vm.fileList.planWriteOffVatInvoice,
                                          "auto-upload": false,
                                          "show-file-list": false,
                                        },
                                      }),
                                      _vm.fileList.planWriteOffVatInvoice &&
                                      _vm.fileList.planWriteOffVatInvoice.length
                                        ? _c(
                                            "ul",
                                            { staticClass: "custom-file-list" },
                                            _vm._l(
                                              _vm.fileList
                                                .planWriteOffVatInvoice,
                                              function (f) {
                                                return _c(
                                                  "li",
                                                  { key: f.name },
                                                  [
                                                    _c(
                                                      "a",
                                                      {
                                                        attrs: {
                                                          href: _vm.toFullUrl(
                                                            f.url
                                                          ),
                                                          target: "_blank",
                                                        },
                                                        on: {
                                                          click: function (
                                                            $event
                                                          ) {
                                                            $event.preventDefault()
                                                            return _vm.openUrl(
                                                              f.url
                                                            )
                                                          },
                                                        },
                                                      },
                                                      [_vm._v(_vm._s(f.name))]
                                                    ),
                                                  ]
                                                )
                                              }
                                            ),
                                            0
                                          )
                                        : _vm._e(),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-row",
                        [
                          _c(
                            "el-col",
                            {
                              staticStyle: { height: "auto" },
                              attrs: { span: 24 },
                            },
                            [
                              _c(
                                "div",
                                { staticStyle: { float: "left" } },
                                [
                                  _c(
                                    "el-form-item",
                                    {
                                      staticClass: "form-item",
                                      attrs: { label: "过路费发票:" },
                                    },
                                    [
                                      _c("el-upload", {
                                        staticClass: "noneupload",
                                        staticStyle: { display: "none" },
                                        attrs: {
                                          action: "",
                                          "on-preview": _vm.onPreviewFun,
                                          "file-list":
                                            _vm.fileList
                                              .planWriteOffTollInvoice,
                                          "auto-upload": false,
                                          "show-file-list": false,
                                        },
                                      }),
                                      _vm.fileList.planWriteOffTollInvoice &&
                                      _vm.fileList.planWriteOffTollInvoice
                                        .length
                                        ? _c(
                                            "ul",
                                            { staticClass: "custom-file-list" },
                                            _vm._l(
                                              _vm.fileList
                                                .planWriteOffTollInvoice,
                                              function (f) {
                                                return _c(
                                                  "li",
                                                  { key: f.name },
                                                  [
                                                    _c(
                                                      "a",
                                                      {
                                                        attrs: {
                                                          href: _vm.toFullUrl(
                                                            f.url
                                                          ),
                                                          target: "_blank",
                                                        },
                                                        on: {
                                                          click: function (
                                                            $event
                                                          ) {
                                                            $event.preventDefault()
                                                            return _vm.openUrl(
                                                              f.url
                                                            )
                                                          },
                                                        },
                                                      },
                                                      [_vm._v(_vm._s(f.name))]
                                                    ),
                                                  ]
                                                )
                                              }
                                            ),
                                            0
                                          )
                                        : _vm._e(),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-row",
                        [
                          _c(
                            "el-col",
                            {
                              staticStyle: { height: "auto" },
                              attrs: { span: 24 },
                            },
                            [
                              _c(
                                "div",
                                { staticStyle: { float: "left" } },
                                [
                                  _c(
                                    "el-form-item",
                                    {
                                      staticClass: "form-item",
                                      attrs: { label: "加油费发票:" },
                                    },
                                    [
                                      _c("el-upload", {
                                        staticClass: "noneupload",
                                        staticStyle: { display: "none" },
                                        attrs: {
                                          action: "",
                                          "on-preview": _vm.onPreviewFun,
                                          "file-list":
                                            _vm.fileList
                                              .planWriteOffFuelInvoice,
                                          "auto-upload": false,
                                          "show-file-list": false,
                                        },
                                      }),
                                      _vm.fileList.planWriteOffFuelInvoice &&
                                      _vm.fileList.planWriteOffFuelInvoice
                                        .length
                                        ? _c(
                                            "ul",
                                            { staticClass: "custom-file-list" },
                                            _vm._l(
                                              _vm.fileList
                                                .planWriteOffFuelInvoice,
                                              function (f) {
                                                return _c(
                                                  "li",
                                                  { key: f.name },
                                                  [
                                                    _c(
                                                      "a",
                                                      {
                                                        attrs: {
                                                          href: _vm.toFullUrl(
                                                            f.url
                                                          ),
                                                          target: "_blank",
                                                        },
                                                        on: {
                                                          click: function (
                                                            $event
                                                          ) {
                                                            $event.preventDefault()
                                                            return _vm.openUrl(
                                                              f.url
                                                            )
                                                          },
                                                        },
                                                      },
                                                      [_vm._v(_vm._s(f.name))]
                                                    ),
                                                  ]
                                                )
                                              }
                                            ),
                                            0
                                          )
                                        : _vm._e(),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-row",
                        [
                          _c(
                            "el-col",
                            {
                              staticStyle: { height: "auto" },
                              attrs: { span: 24 },
                            },
                            [
                              _c(
                                "div",
                                { staticStyle: { float: "left" } },
                                [
                                  _c(
                                    "el-form-item",
                                    {
                                      staticClass: "form-item",
                                      attrs: { label: "费用凭证:" },
                                    },
                                    [
                                      _c("el-upload", {
                                        staticClass: "noneupload",
                                        staticStyle: { display: "none" },
                                        attrs: {
                                          action: "",
                                          "on-preview": _vm.onPreviewFun,
                                          "file-list":
                                            _vm.fileList.planWriteOffVoucher,
                                          "auto-upload": false,
                                          "show-file-list": false,
                                        },
                                      }),
                                      _vm.fileList.planWriteOffVoucher &&
                                      _vm.fileList.planWriteOffVoucher.length
                                        ? _c(
                                            "ul",
                                            { staticClass: "custom-file-list" },
                                            _vm._l(
                                              _vm.fileList.planWriteOffVoucher,
                                              function (f) {
                                                return _c(
                                                  "li",
                                                  { key: f.name },
                                                  [
                                                    _c(
                                                      "a",
                                                      {
                                                        attrs: {
                                                          href: _vm.toFullUrl(
                                                            f.url
                                                          ),
                                                          target: "_blank",
                                                        },
                                                        on: {
                                                          click: function (
                                                            $event
                                                          ) {
                                                            $event.preventDefault()
                                                            return _vm.openUrl(
                                                              f.url
                                                            )
                                                          },
                                                        },
                                                      },
                                                      [_vm._v(_vm._s(f.name))]
                                                    ),
                                                  ]
                                                )
                                              }
                                            ),
                                            0
                                          )
                                        : _vm._e(),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ]
                          ),
                          _c(
                            "el-col",
                            {
                              staticStyle: { height: "auto" },
                              attrs: { span: 24 },
                            },
                            [
                              _c(
                                "div",
                                { staticStyle: { float: "left" } },
                                [
                                  _c(
                                    "el-form-item",
                                    {
                                      staticClass: "form-item",
                                      attrs: { label: "合同:" },
                                    },
                                    [
                                      _c("el-upload", {
                                        staticClass: "noneupload",
                                        staticStyle: { display: "none" },
                                        attrs: {
                                          action: "",
                                          "on-preview": _vm.onPreviewFun,
                                          "file-list":
                                            _vm.fileList.planWriteOffContract,
                                          "auto-upload": false,
                                          "show-file-list": false,
                                        },
                                      }),
                                      _vm.fileList.planWriteOffContract &&
                                      _vm.fileList.planWriteOffContract.length
                                        ? _c(
                                            "ul",
                                            { staticClass: "custom-file-list" },
                                            _vm._l(
                                              _vm.fileList.planWriteOffContract,
                                              function (f) {
                                                return _c(
                                                  "li",
                                                  { key: f.name },
                                                  [
                                                    _c(
                                                      "a",
                                                      {
                                                        attrs: {
                                                          href: _vm.toFullUrl(
                                                            f.url
                                                          ),
                                                          target: "_blank",
                                                        },
                                                        on: {
                                                          click: function (
                                                            $event
                                                          ) {
                                                            $event.preventDefault()
                                                            return _vm.openUrl(
                                                              f.url
                                                            )
                                                          },
                                                        },
                                                      },
                                                      [_vm._v(_vm._s(f.name))]
                                                    ),
                                                  ]
                                                )
                                              }
                                            ),
                                            0
                                          )
                                        : _vm._e(),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ]
                          ),
                          _c(
                            "el-row",
                            [
                              _c(
                                "el-col",
                                {
                                  staticStyle: { height: "auto" },
                                  attrs: { span: 24 },
                                },
                                [
                                  _c(
                                    "el-form-item",
                                    { attrs: { label: "活动照片:" } },
                                    [
                                      _c(
                                        "el-upload",
                                        {
                                          ref: "upload",
                                          attrs: {
                                            disabled: true,
                                            action: "#",
                                            "auto-upload": false,
                                          },
                                        },
                                        [
                                          _c(
                                            "vxe-button",
                                            {
                                              attrs: {
                                                icon: "el-icon-view",
                                                type: "primary",
                                              },
                                              on: { click: _vm.openPicDialog },
                                            },
                                            [_vm._v("乘龙图片库")]
                                          ),
                                          _vm.selectImgInfoList.length > 0
                                            ? _c(
                                                "vxe-button",
                                                {
                                                  attrs: {
                                                    icon: "el-icon-download",
                                                    type: "primary",
                                                    loading: _vm.downLoading,
                                                  },
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.onDownloadPic(
                                                        0
                                                      )
                                                    },
                                                  },
                                                },
                                                [_vm._v("下载图片")]
                                              )
                                            : _vm._e(),
                                        ],
                                        1
                                      ),
                                      _vm.selectImgInfoList.length > 0
                                        ? _c(
                                            "div",
                                            {
                                              staticClass: "pic-box scrollBars",
                                            },
                                            _vm._l(
                                              _vm.selectImgInfoList,
                                              function (item, index) {
                                                return _c(
                                                  "div",
                                                  {
                                                    key: index,
                                                    staticClass: "image-item2",
                                                  },
                                                  [
                                                    _c(
                                                      "el-image",
                                                      {
                                                        staticStyle: {
                                                          width: "180px",
                                                          height: "180px",
                                                        },
                                                        attrs: {
                                                          src: item.url,
                                                          "preview-src-list":
                                                            _vm.selectImgInfoList.map(
                                                              function (val) {
                                                                return val.url
                                                              }
                                                            ),
                                                          lazy: "",
                                                          fit: "cover",
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "image-slot",
                                                            attrs: {
                                                              slot: "placeholder",
                                                            },
                                                            slot: "placeholder",
                                                          },
                                                          [
                                                            _c("i", {
                                                              staticClass:
                                                                "el-icon-loading",
                                                            }),
                                                          ]
                                                        ),
                                                      ]
                                                    ),
                                                  ],
                                                  1
                                                )
                                              }
                                            ),
                                            0
                                          )
                                        : _vm._e(),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            {
                              staticStyle: { height: "auto" },
                              attrs: { span: 24 },
                            },
                            [
                              _c(
                                "div",
                                { staticStyle: { float: "left" } },
                                [
                                  _c(
                                    "el-form-item",
                                    {
                                      staticClass: "form-item",
                                      attrs: { label: "其他材料附件:" },
                                    },
                                    [
                                      _c("el-upload", {
                                        staticClass: "noneupload",
                                        staticStyle: { display: "none" },
                                        attrs: {
                                          action: "",
                                          "on-preview": _vm.onPreviewFun,
                                          "file-list":
                                            _vm.fileList
                                              .planWriteOffAttachments,
                                          "auto-upload": false,
                                          "show-file-list": false,
                                        },
                                      }),
                                      _vm.fileList.planWriteOffAttachments &&
                                      _vm.fileList.planWriteOffAttachments
                                        .length
                                        ? _c(
                                            "ul",
                                            { staticClass: "custom-file-list" },
                                            _vm._l(
                                              _vm.fileList
                                                .planWriteOffAttachments,
                                              function (f) {
                                                return _c(
                                                  "li",
                                                  { key: f.name },
                                                  [
                                                    _c(
                                                      "a",
                                                      {
                                                        attrs: {
                                                          href: _vm.toFullUrl(
                                                            f.url
                                                          ),
                                                          target: "_blank",
                                                        },
                                                        on: {
                                                          click: function (
                                                            $event
                                                          ) {
                                                            $event.preventDefault()
                                                            return _vm.openUrl(
                                                              f.url
                                                            )
                                                          },
                                                        },
                                                      },
                                                      [_vm._v(_vm._s(f.name))]
                                                    ),
                                                  ]
                                                )
                                              }
                                            ),
                                            0
                                          )
                                        : _vm._e(),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c("checkHistory", {
            attrs: {
              "find-hist-tasks-data": _vm.findHistTasksData,
              "writeoff-task-data": _vm.findWriteoffTasksData,
            },
          }),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "审批信息",
            visible: _vm.dialogVisible,
            width: "40%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
          },
        },
        [
          _vm.approveTypeName === "转 派"
            ? _c(
                "div",
                {
                  staticClass: "demo-input-suffix",
                  staticStyle: { "padding-bottom": "20px" },
                },
                [
                  _vm._v(" 转派人： "),
                  _c("el-input", {
                    staticStyle: { width: "35%" },
                    attrs: { placeholder: "请选择转派的用户" },
                    on: { focus: _vm.chooseUser },
                    model: {
                      value: _vm.operatorUser,
                      callback: function ($$v) {
                        _vm.operatorUser = $$v
                      },
                      expression: "operatorUser",
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
          _vm.approveTypeName === "同 意"
            ? _c(
                "div",
                {
                  staticClass: "demo-input-suffix",
                  staticStyle: { "padding-bottom": "20px" },
                },
                [
                  _vm._v(" 审核金额： "),
                  _c("el-input-number", {
                    attrs: {
                      precision: 2,
                      "controls-position": "right",
                      step: 0.1,
                      min: 0.0,
                      max: _vm.calculateMaxApproveCost(),
                      controls: false,
                      disabled: !_vm.isDisabled(),
                    },
                    model: {
                      value: _vm.approveCost,
                      callback: function ($$v) {
                        _vm.approveCost = $$v
                      },
                      expression: "approveCost",
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
          _vm.approveTypeName === "同 意" &&
          JSON.stringify(this.permissions).includes("kaoping")
            ? _c(
                "div",
                {
                  staticClass: "demo-input-suffix",
                  staticStyle: { "padding-bottom": "20px" },
                },
                [
                  _vm._v(" 考评金额： "),
                  _c("el-input-number", {
                    attrs: {
                      precision: 2,
                      lable: "考评金额",
                      "controls-position": "right",
                      step: 0.1,
                      placeholder: "请输入考评金额（正数奖励，负数扣罚）",
                      controls: false,
                    },
                    model: {
                      value: _vm.assessmentCost,
                      callback: function ($$v) {
                        _vm.assessmentCost = $$v
                      },
                      expression: "assessmentCost",
                    },
                  }),
                  _vm.errorMessage
                    ? _c("p", { staticStyle: { color: "red" } }, [
                        _vm._v(_vm._s(_vm.errorMessage)),
                      ])
                    : _vm._e(),
                ],
                1
              )
            : _vm._e(),
          _vm.approveTypeName === "同 意"
            ? _c(
                "div",
                {
                  staticClass: "demo-input-suffix",
                  staticStyle: { "padding-bottom": "20px" },
                },
                [
                  _vm._v(" 结算金额： "),
                  _c("el-input-number", {
                    staticStyle: {
                      width: "180px",
                      "background-color": "#f5f7fa",
                    },
                    attrs: {
                      disabled: "",
                      precision: 2,
                      "controls-position": "right",
                      controls: false,
                    },
                    model: {
                      value: _vm.settlementAmount,
                      callback: function ($$v) {
                        _vm.settlementAmount = $$v
                      },
                      expression: "settlementAmount",
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
          _c("el-input", {
            attrs: {
              type: "textarea",
              placeholder: "请输入审批意见",
              maxlength: "300",
              "show-word-limit": "",
            },
            model: {
              value: _vm.approveMsg,
              callback: function ($$v) {
                _vm.approveMsg = $$v
              },
              expression: "approveMsg",
            },
          }),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "vxe-button",
                {
                  attrs: { loading: _vm.approveBtnLoading, type: "primary" },
                  on: {
                    click: function ($event) {
                      return _vm.approve()
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.approveTypeName))]
              ),
              _c(
                "vxe-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.dialogVisible = false
                    },
                  },
                },
                [_vm._v("取 消")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "选择用户",
            visible: _vm.userDialogVisible,
            width: "75%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.userDialogVisible = $event
            },
          },
        },
        [
          _c(
            "div",
            { staticStyle: { "margin-bottom": "20px" } },
            [
              _c("el-input", {
                style: { width: "80%" },
                attrs: { placeholder: "输入用户名称", clearable: "" },
                on: { change: _vm.handleFilter },
                model: {
                  value: _vm.userName,
                  callback: function ($$v) {
                    _vm.userName = $$v
                  },
                  expression: "userName",
                },
              }),
              _c(
                "vxe-button",
                {
                  staticClass: "filter-search-item",
                  staticStyle: { float: "right" },
                  attrs: { type: "primary", icon: "el-icon-search" },
                  on: { click: _vm.handleFilter },
                },
                [_vm._v("查询")]
              ),
            ],
            1
          ),
          _c(
            "vxe-table",
            {
              ref: "Xuser",
              attrs: {
                border: "",
                "show-header-overflow": "",
                "show-overflow": "",
                "column-config": { resizable: true },
                stripe: "",
                round: "",
                loading: _vm.userLoading,
                "max-height": "350",
                align: "center",
                "scroll-y": { enabled: false },
                data: _vm.userLists,
                reserve: true,
                "row-config": { isCurrent: true, isHover: true },
                "radio-config": {
                  strict: false,
                  labelField: "seq",
                  trigger: "row",
                  isCurrent: true,
                  isHover: true,
                },
              },
            },
            [
              _c("vxe-column", { attrs: { type: "radio", width: "60" } }),
              _c("vxe-column", {
                attrs: { visible: false, field: "id", title: "用户id" },
              }),
              _c("vxe-column", {
                attrs: { type: "seq", title: "序号", width: "60" },
              }),
              _c("vxe-column", {
                attrs: { field: "name", title: "用户名称", width: "110" },
              }),
              _c("vxe-column", {
                attrs: { field: "department", title: "所属组织结构" },
              }),
            ],
            1
          ),
          _c("vxe-pager", {
            attrs: {
              loading: _vm.userLoading,
              "current-page": _vm.addTablePage.currentPage,
              "page-size": _vm.addTablePage.pageSize,
              total: _vm.addTablePage.totalResult,
              layouts: [
                "PrevPage",
                "JumpNumber",
                "NextPage",
                "FullJump",
                "Sizes",
                "Total",
              ],
            },
            on: { "page-change": _vm.handlePageChange },
          }),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "vxe-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.userDialogVisible = false
                    },
                  },
                },
                [_vm._v("取 消")]
              ),
              _c(
                "vxe-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function ($event) {
                      return _vm.handleChooseUser()
                    },
                  },
                },
                [_vm._v("确 定")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "乘龙图片库",
            visible: _vm.PictureBase.OutBox,
            "close-on-click-modal": false,
            width: "45%",
          },
          on: {
            "update:visible": function ($event) {
              return _vm.$set(_vm.PictureBase, "OutBox", $event)
            },
          },
        },
        [
          _vm.allImgInfoList.length > 0
            ? _c(
                "div",
                [
                  _c(
                    "vxe-button",
                    {
                      staticStyle: { margin: "0 0 10px 10px" },
                      attrs: {
                        type: "primary",
                        icon: "el-icon-download",
                        loading: _vm.downLoading,
                      },
                      on: {
                        click: function ($event) {
                          return _vm.onDownloadPic(1)
                        },
                      },
                    },
                    [_vm._v("下载图片")]
                  ),
                  _c(
                    "div",
                    { staticClass: "picDialog scrollBars" },
                    _vm._l(_vm.allImgInfoList, function (item) {
                      return _c(
                        "div",
                        { key: item.id, staticClass: "image-item" },
                        [
                          _c(
                            "div",
                            { staticClass: "img" },
                            [
                              _c(
                                "el-image",
                                {
                                  staticStyle: {
                                    width: "180px",
                                    height: "180px",
                                  },
                                  attrs: {
                                    "preview-src-list": _vm.allImgInfoList.map(
                                      function (item) {
                                        return item.url
                                      }
                                    ),
                                    src: item.url,
                                    fit: "cover",
                                    lazy: "",
                                  },
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "image-slot",
                                      attrs: { slot: "placeholder" },
                                      slot: "placeholder",
                                    },
                                    [
                                      _c("i", {
                                        staticClass: "el-icon-loading",
                                      }),
                                    ]
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                        ]
                      )
                    }),
                    0
                  ),
                ],
                1
              )
            : _c("div", { staticClass: "null-tip" }, [_vm._v(" 暂无图片 ")]),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "vxe-button",
                {
                  attrs: { status: "primary" },
                  on: {
                    click: function ($event) {
                      _vm.PictureBase.OutBox = false
                    },
                  },
                },
                [_vm._v("关 闭")]
              ),
            ],
            1
          ),
        ]
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "客户详情",
            visible: _vm.customerModalVisible,
            "close-on-click-modal": false,
            width: "80%",
            top: "5vh",
          },
          on: {
            "update:visible": function ($event) {
              _vm.customerModalVisible = $event
            },
          },
        },
        [
          _c(
            "div",
            { staticStyle: { height: "60vh", overflow: "auto" } },
            [
              _c(
                "vxe-table",
                {
                  attrs: {
                    data: _vm.customerList,
                    loading: _vm.customerLoading,
                    border: "",
                    stripe: "",
                    height: "100%",
                    "scroll-y": { enabled: true },
                  },
                },
                [
                  _c("vxe-column", {
                    attrs: { type: "seq", title: "序号", width: "60" },
                  }),
                  _c("vxe-column", {
                    attrs: { field: "actCode", title: "活动提报编号" },
                  }),
                  _c("vxe-column", {
                    attrs: { field: "customerName", title: "客户姓名" },
                  }),
                  _c("vxe-column", {
                    attrs: { field: "mobile", title: "手机号" },
                  }),
                  _c("vxe-column", {
                    attrs: { field: "createTime", title: "扫码时间" },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "vxe-button",
                {
                  attrs: { status: "primary" },
                  on: {
                    click: function ($event) {
                      _vm.customerModalVisible = false
                    },
                  },
                },
                [_vm._v("关 闭")]
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }